"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuthInfoByCode = getAuthInfoByCode;
exports.getAuthBaseUrl = getAuthBaseUrl;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _http = _interopRequireDefault(require("commons.js/http"));

var _config = _interopRequireDefault(require("../../utils/config"));

function getApiOrigin() {
  var isServerSide = typeof window === 'undefined'; // 兼容测试环境的服务端渲染的接口调用，在测试环境的服务端使用服务名的方式调用接口，用域名的方式会访问生产环境的接口

  var apiOrigin = isServerSide ? _config["default"].get('SERVER_SIDE_USER_CENTER_API_ORIGIN') : _config["default"].get('API_ORIGIN');
  return apiOrigin;
}

function getAuthInfoByCode(_x) {
  return _getAuthInfoByCode.apply(this, arguments);
}

function _getAuthInfoByCode() {
  _getAuthInfoByCode = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(code) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _http["default"].get(getApiOrigin() + "/user-center/token/get?code=".concat(code)));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getAuthInfoByCode.apply(this, arguments);
}

function getAuthBaseUrl(_x2) {
  return _getAuthBaseUrl.apply(this, arguments);
}

function _getAuthBaseUrl() {
  _getAuthBaseUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(appId) {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _http["default"].get(getApiOrigin() + "/user-center/config/authBaseUrl?appId=".concat(appId)));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getAuthBaseUrl.apply(this, arguments);
}